export const getKeysData = (object = {}, array = []) => {
    return (
        array.reduce((result, key) => {
            if (Array.isArray(key)) {
                result[key[1]] = object?.[key?.[0]];
            } else {
                result[key] = object?.[key];
            }
            return result;
        }, {}) || {}
    );
};
export const getKeysDataIfExist = (object = {}, array = []) => {
    return (
        array.reduce((result, key) => {
            if (Array.isArray(key)) {
                object?.[key?.[0]] && (result[key[1]] = object?.[key?.[0]]);
            } else {
                object?.[key] && (result[key] = object?.[key]);
            }
            return result;
        }, {}) || {}
    );
};

export const handleInputChange = (state, field, value) => {
    state(prev => ({
        ...prev,
        [field]: value
    }));
};

